export enum Role {
  DealerAccountManager = 'GlobalWarrantyDealerAccountManager',
  RegionalSalesManager = 'GlobalWarrantyRegionalSalesManager',
  ClaimsManager = 'GlobalWarrantyClaimsManager'
}
